<div class="flex h-full flex-col gap-y-4 overflow-hidden">
    <!-- Content -->

    @if (userVisits() && userVisits()!.length > 0) {
    <div class="flex h-full flex-1 flex-col overflow-hidden">
        <div class="shrink-0 flex flex-row items-center justify-between px-2 py-3">
            <div class="flex items-center gap-x-4">
                <div class="shrink-0">
                    <img [src]="imageService.getImageSource(selectedBusinessUser()?.userAccount?.photoURL, 'gallery')"
                        alt=""
                        class="size-12 rounded-full bg-gray-50 dark:bg-gray-800 dark:outline dark:-outline-offset-1 dark:outline-white/10" />
                </div>
                <div class="">
                    <h3 class="text-base font-semibold text-gray-900 dark:text-white">{{
                        memberDisplayName(selectedBusinessUser()!) }}</h3>
                    <p class="text-sm text-gray-500 dark:text-gray-400">
                        {{ selectedBusinessUser()?.userAccount?.email }}
                    </p>
                </div>
            </div>
            <div class="flex shrink-0">
                <div class="flex h-full shrink-0 flex-row items-center gap-x-2">
                    <label class="sr-only" for="visits-user-select">Team member</label>
                    <select id="visits-user-select" (change)="onUserSelect($event)"
                        class="cursor-pointer rounded-md bg-white px-3 py-1.5 text-sm text-primary outline-1 -outline-offset-1 outline-gray-300 focus:outline-2 focus:-outline-offset-2 focus:outline-primary dark:bg-zinc-800 dark:outline-zinc-600 dark:focus-visible:outline-primary">
                        @for (member of activeUsers(); track member.id) {
                        <option [value]="member.userAccount.firebaseUid"
                            [selected]="member.userAccount.firebaseUid === selectedBusinessUser()?.userAccount?.firebaseUid">
                            {{ memberDisplayName(member) }}
                        </option>
                        }
                    </select>
                </div>
            </div>
        </div>
        <div class="min-h-0 flex-1 overflow-x-auto overflow-y-auto scrollbar-transparent">
            <table class="min-w-full divide-y divide-gray-300 dark:divide-gray-700">
                <thead class="sticky top-0 z-10 bg-gray-100 dark:bg-gray-900/50">
                    <tr>
                        <th scope="col"
                            class="py-2 pr-3 pl-2 text-left text-sm font-semibold whitespace-nowrap text-primary">
                            Date Visited
                        </th>
                        <th scope="col"
                            class="px-2 py-3.5 text-left text-sm font-semibold whitespace-nowrap text-primary">
                            Browser
                        </th>
                        <th scope="col"
                            class="px-2 py-3.5 text-left text-sm font-semibold whitespace-nowrap text-primary">
                            OS
                        </th>
                        <th scope="col"
                            class="px-2 py-3.5 text-left text-sm font-semibold whitespace-nowrap text-primary">
                            Device
                        </th>
                        <th scope="col"
                            class="px-2 py-3.5 text-left text-sm font-semibold whitespace-nowrap text-primary">
                            Platform
                        </th>
                    </tr>
                </thead>
                <tbody class="divide-y divide-gray-200 dark:divide-gray-700">
                    @for (visit of userVisits(); track visit.id) {
                    <tr>
                        <td class="py-2 pr-3 pl-2 text-sm whitespace-nowrap text-primary">
                            <div class="font-medium text-primary">
                                {{ visit.dateVisited | date: 'dd MMM yy HH:mm' }}
                            </div>
                        </td>
                        <td class="px-2 py-2 text-sm whitespace-nowrap text-primary">
                            @if (visit.deviceInfo.browser) {
                            <span>{{ visit.deviceInfo.browser }}</span>
                            <span class="ml-1 text-xs text-gray-500 dark:text-gray-400">{{
                                visit.deviceInfo.browser_version }}</span>
                            } @else {
                            <span class="text-xs text-gray-500 dark:text-gray-400">N/A</span>
                            }
                        </td>
                        <td class="px-2 py-2 text-sm whitespace-nowrap text-primary">
                            @if (visit.deviceInfo.os) {
                            <span>{{ visit.deviceInfo.os }}</span>
                            <span class="ml-1 text-xs text-gray-500 dark:text-gray-400">{{ visit.deviceInfo.os_version
                                }}</span>
                            } @else {
                            <span class="text-xs text-gray-500 dark:text-gray-400">N/A</span>
                            }
                        </td>
                        <td class="px-2 py-2 text-sm whitespace-nowrap text-primary">
                            @if (visit.deviceInfo.deviceType) {
                            <span>{{ visit.deviceInfo.deviceType }}</span>
                            } @else {
                            <span class="text-xs text-gray-500 dark:text-gray-400">N/A</span>
                            }
                        </td>
                        <td class="px-2 py-2 text-sm whitespace-nowrap text-primary">
                            @if (visit.platform || visit.requestAgent) {
                            <span>{{ visit.platform || (visit.requestAgent | slice:0:40) }}</span>
                            } @else {
                            <span class="text-xs text-gray-500 dark:text-gray-400">N/A</span>
                            }
                        </td>
                    </tr>
                    }
                </tbody>
            </table>
        </div>

    </div>
    } @else if (userVisits() && userVisits()!.length === 0) {
    <div class="flex h-full flex-1 flex-col overflow-hidden">
        <div class="shrink-0 flex flex-row items-center justify-between px-2 py-3">
            <div class="flex items-center gap-x-4">
                <div class="shrink-0">
                    <img [src]="imageService.getImageSource(selectedBusinessUser()?.userAccount?.photoURL, 'gallery')"
                        alt=""
                        class="size-12 rounded-full bg-gray-50 dark:bg-gray-800 dark:outline dark:-outline-offset-1 dark:outline-white/10" />
                </div>
                <div class="">
                    <h3 class="text-base font-semibold text-gray-900 dark:text-white">{{
                        memberDisplayName(selectedBusinessUser()!) }}</h3>
                    <p class="text-sm text-gray-500 dark:text-gray-400">
                        {{ selectedBusinessUser()?.userAccount?.email }}
                    </p>
                </div>
            </div>
            <div class="flex shrink-0">
                <div class="flex h-full shrink-0 flex-row items-center gap-x-2">
                    <label class="sr-only" for="visits-user-select">Team member</label>
                    <select id="visits-user-select" (change)="onUserSelect($event)"
                        class="cursor-pointer rounded-md bg-white px-3 py-1.5 text-sm text-primary outline-1 -outline-offset-1 outline-gray-300 focus:outline-2 focus:-outline-offset-2 focus:outline-primary dark:bg-zinc-800 dark:outline-zinc-600 dark:focus-visible:outline-primary">
                        @for (member of activeUsers(); track member.id) {
                        <option [value]="member.userAccount.firebaseUid"
                            [selected]="member.userAccount.firebaseUid === selectedBusinessUser()?.userAccount?.firebaseUid">
                            {{ memberDisplayName(member) }}
                        </option>
                        }
                    </select>
                </div>
            </div>
        </div>
        <div class="min-h-0 flex-1 overflow-x-auto overflow-y-auto scrollbar-transparent">
        </div>
    </div>
    } @else {
    <div class="flex h-full flex-1 flex-col overflow-hidden">
        <div class="shrink-0 flex flex-row items-center justify-between px-2 py-3">
            <div class="flex items-center gap-x-4">
                <div class="shrink-0">
                    <img [src]="imageService.getImageSource(selectedBusinessUser()?.userAccount?.photoURL, 'gallery')"
                        alt=""
                        class="size-12 rounded-full bg-gray-50 dark:bg-gray-800 dark:outline dark:-outline-offset-1 dark:outline-white/10" />
                </div>
                <div class="">
                    <h3 class="text-base font-semibold text-gray-900 dark:text-white">{{
                        memberDisplayName(selectedBusinessUser()!) }}</h3>
                    <p class="text-sm text-gray-500 dark:text-gray-400">
                        {{ selectedBusinessUser()?.userAccount?.email }}
                    </p>
                </div>
            </div>
            <div class="flex shrink-0">
                <div class="flex h-full shrink-0 flex-row items-center gap-x-2">
                    <label class="sr-only" for="visits-user-select">Team member</label>
                    <select id="visits-user-select" (change)="onUserSelect($event)"
                        class="cursor-pointer rounded-md bg-white px-3 py-1.5 text-sm text-primary outline-1 -outline-offset-1 outline-gray-300 focus:outline-2 focus:-outline-offset-2 focus:outline-primary dark:bg-zinc-800 dark:outline-zinc-600 dark:focus-visible:outline-primary">
                        @for (member of activeUsers(); track member.id) {
                        <option [value]="member.userAccount.firebaseUid"
                            [selected]="member.userAccount.firebaseUid === selectedBusinessUser()?.userAccount?.firebaseUid">
                            {{ memberDisplayName(member) }}
                        </option>
                        }
                    </select>
                </div>
            </div>
        </div>
        <div class="flex-1 overflow-x-auto overflow-y-auto scrollbar-transparent justify-center items-center">
            <div class="text-center">
                <svg aria-hidden="true"
                    class="mx-auto w-12 h-12 text-gray-200 animate-spin dark:text-gray-300 fill-primary"
                    viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                        fill="currentColor" />
                    <path
                        d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                        fill="currentFill" />
                </svg>
                <h3 class="mt-2 text-sm font-semibold text-gray-900 dark:text-white">Loading visits</h3>
                <p class="mt-1 text-sm text-gray-500 dark:text-gray-400">Should be done in a moment.</p>
            </div>
        </div>
    </div>
    }

</div>